import React from "react";
import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import Footer from "../components/Footers";
import Header from "../components/Header";

const TermOfService = () =>{

    const [isOpenChangeAgree, setIsOpenChangeAgree] = useState(true)
    const [isOpenRestriction, setIsOpenRestriction] = useState(true)
    const [isOpenGeneralTerm, setIsOpenGeneralTerm] = useState(true)
    const [isOpenPrivacyPolicy, setIsOpenPrivacyPolicy] = useState(true)
    const [isOpenLicense, setIsOpenLicense] = useState(true)
    const [isOpenProhibitedBehaviour, setIsOpenProhibitedBehaviour] = useState(true)
    const [isOpenAvaibility, setIsOpenAvaibility] = useState(true)
    const [isOpenCharges, setIsOpenCharges] = useState(true)
    const [isOpenSources, setIsOpenSources] = useState(true)
    const [isOpenDisclaimer, setIsOpenDisclaimer] = useState(true)
    const [isOpenLimitation, setIsOpenLimitation] = useState(true)
    const [isOpenLegal, setIsOpenLegal] = useState(true)
    const [isOpenGoverning, setIsOpenGoverning] = useState(true)
    const [isOpenTernimation, setIsOpenTernimation] = useState(true)
    const [isOpenSeverability, setIsOpenSeverability] = useState(true)
    const [isOpenContactInfo, setIsOpenContactInfo] = useState(true)

    return (
        <div className="bg-levi-bg min-h-screen">
            <Header />
            <div className="relative w-full bg-levi-bg pt-32 pb-24 overflow-hidden border-b border-levi-border">
                <div className="absolute inset-0 bg-grid-red bg-[size:60px_60px] opacity-30" />
                <div className="absolute -top-32 right-0 w-[400px] h-[400px] bg-levi-primary/20 blur-[120px] rounded-full" />
                <div className="container-xl relative text-center">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="h-px w-12 bg-levi-primary" />
                        <span className="eyebrow">Legal</span>
                        <span className="h-px w-12 bg-levi-primary" />
                    </div>
                    <h1 className="display-lg text-levi-text">Terms of Use</h1>
                    <p className="mt-4 font-mono text-sm text-levi-muted tracking-widest uppercase">
                        Last updated · April 20, 2025
                    </p>
                </div>
            </div>

            <div className="xl:max-w-[80%] xl:p-20 lg:max-w-[80%] lg:p-16 md:max-w-[80%] md:p-10 sm:max-w-[80%] sm:p-5 max-w-[90%]
            mx-auto bg-stone-50 border border-levi-border my-16 p-5"
               style={{
                boxShadow: "rgba(0, 0, 0, 0.5) 0px 20px 60px -20px"
              }}>

                <hr className="sm:my-12 mt-6 mb-16 border-gray-300" />


                <p className="mt-4 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                    These Terms of Use and End User License Agreement (collectively, the “Agreement”) together with all the documents referred 
                    to in it constitute a legally binding agreement made between you as a natural person (“you”, “your” or “user”) and Phuc Pham. 
                    (“we,” “us” or “our”), concerning your access to and use of the Website, available at 
                    {" "} <a href="/" className="text-red-700 hover:underline"> https://web-levi.web.app </a>{" "} 
                    (here in after, the “Website”).
                </p>

                <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                    All the documents that relate to the Website are hereby expressly incorporated herein by reference.
                </p>
                
                <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                    Please read this Agreement carefully before using the Website.
                </p>
                <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                    It is important that you read and understand this Agreement as by using the Website you indicate that you have read, 
                    understood, agreed and accepted the Agreement. By using the Website you agree to abide by this Agreement.
                </p>
                <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                    If you do not agree with (do not accept) this Agreement, or if you do not agree at least with one of the provisions of this Agreement, 
                    you are not authorized to access or use the Website and you must promptly discontinue accessing and/or using the Website.
                </p>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenChangeAgree(!isOpenChangeAgree)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Changes to this agreement
                        </p>
                        {isOpenChangeAgree ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenChangeAgree && (
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                            We reserve the right, at our sole discretion, to make changes or modifications to this Agreement at any time and for any reason. 
                            We will keep you informed about any changes by updating this Agreement and you waive any right to receive specific notice of each such change. 
                            It is your responsibility to periodically review this Agreement to stay informed of updates. You will be subject to, and will be deemed to be 
                            aware of and to have accepted, the changes in any revised Agreement by your continued use of the Website after the date such revised Agreement 
                            is posted.
                        </p>
                    )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenRestriction(!isOpenRestriction)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Restrictions on who can use the website
                        </p>
                        {isOpenRestriction ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenRestriction && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                In order to access and/or use the Website, you must be eighteen (18) years of age or older.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                All users who are minors in the jurisdiction in which they reside (generally under the age of 18) must have the permission of, 
                                and be directly supervised by their parent or guardian to access and/or use the Website, so if you are between the ages of thirteen 
                                (13) and seventeen (17) years and you wish to access and/or use the Website, before doing so you must: (a) assure and confirm (if needed) 
                                that your parent or guardian have read and agreed (get your parent or guardian’s consent) to this Agreement prior to your access and/or 
                                use the Website; (b) have the power to enter a binding contract with us and not be barred from doing so under any applicable laws.
                            </p>
                            
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Parents and guardians must directly supervise any access and/or use of the Website by minors.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-medium italic">
                                Any person under the age of thirteen (13) years is not permitted to access and/or use the Website.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                You affirm that you are either more than eighteen (18) years of age, or an emancipated minor, or possess legal parental or guardian consent,
                                and are fully able and competent to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth
                                in this Agreement, and to abide by and comply with this Agreement.
                            </p>

                        </>
                    )}
                </div>
                               
                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenGeneralTerm(!isOpenGeneralTerm)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            General Terms
                        </p>
                        {isOpenGeneralTerm ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenGeneralTerm && (
                         <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            The Website is developed for general information purposes and is intended only for your personal non-commercial use. 
                            You agree not to use the Website for any illegal, inappropriate or unauthorized purpose or activity.
                        </p>

                    )}
                </div>

                 <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenPrivacyPolicy(!isOpenPrivacyPolicy)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Privacy Policy
                        </p>
                        {isOpenPrivacyPolicy ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenPrivacyPolicy && (
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            Your privacy is very important to us. Accordingly, we have developed the Privacy Policy in order for you to understand how we process, 
                            use and store information including personal data. Access to and(/or) using the Website are subject to the Privacy Policy. By accessing and(/or) 
                            using the Website, you are deemed to have accepted the Privacy Policy, and in particular, you are deemed to have acknowledged the ways 
                            we process your information as well as appropriate legal grounds for processing described in the Privacy Policy. We reserve the right to 
                            amend the Privacy Policy from time to time. If you disagree with any part of the Privacy Policy, you must immediately stop accessing and(/or) 
                            using the Website. Please read our{" "} <a href="/privacy-policy" className="text-red-700 underline hover:no-underline"> Privacy Policy </a>{" "} carefully.
                        </p>
                    )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenLicense(!isOpenLicense)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            End user license agreement
                        </p>
                        {isOpenLicense ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenLicense && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                By using the Website, you undertake to respect our intellectual rights (intellectual rights related to the Website’s source code, 
                                graphic design, user interface, look and feel of the Website, content material, copyright and trademarks, hereinafter referred to as the 
                                “Intellectual Property Rights”) as well as those owned by third parties.
                            </p>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                As long as you keep using the Website, we grant you a limited, non-exclusive, non-transferable, non-sublicensable, 
                                non-assignable and revocable right to access and use the Website pursuant to this Agreement (the “License”).
                            </p>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-medium italic">
                                You may use our Website solely for your own non-commercial purposes. You are bound to respect the copyrighted material within 
                                the Website, you cannot sell pictures available on the Website. 
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                The source code, design and content, including information, photographs, illustrations, artwork and other graphic materials, 
                                sounds, music or video (hereinafter – the “works”) as well as names, logos and trademarks (hereinafter – “means of individualization”) 
                                within the Website are protected by copyright laws and other relevant laws and/or international treaties, and belong to us and/or our 
                                partners and/or contracted third parties, as the case may be.
                            </p>   

                            
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                These works and means of individualization may not be copied, reproduced, retransmitted, distributed, disseminated, sold, published, 
                                broadcasted or circulated whether in whole or in part, unless expressly permitted by us and/or our partners and/or contracted third parties, 
                                as the case may be.
                            </p>   

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                All rights, title and interest in and to the Website and its content, works and means of individualization as well as its 
                                functionalities (1) are the exclusive property of Phuc Pham and/or our partners and/or contracted third parties, (2) are protected 
                                by the applicable international and national legal provisions, and (3) are under no circumstances transferred (assigned) to you in 
                                full or in part within the context of the license herewithin.
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We will not hesitate to take legal action against any unauthorized use of our trademarks, names or symbols to protect and restore our rights.
                                All rights not expressly granted herein are reserved. Other product and company names displayed on the Website or mentioned herein may also 
                                be the trademarks of their respective owners.
                            </p> 
                        </>
                    )}
                </div>

                
                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenProhibitedBehaviour(!isOpenProhibitedBehaviour)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Prohibited behaviour
                        </p>
                        {isOpenProhibitedBehaviour ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenProhibitedBehaviour && (
                        <>
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                            You agree not to use the Website in any way that:
                        </p>

                        <ul className="text-[#323232] sm:text-[16px] text-[14px]  font-poppins list-disc list-inside mt-3">
                            <li className="mt-2">
                                Is unlawful, illegal or unauthorized;
                            </li>
                            <li className="mt-2">
                                Is defamatory of any other person; 
                            </li>
                            <li className="mt-2">
                                Is obscene or offensive;  
                            </li>
                            <li className="mt-2">
                                Infringes any copyright, database right or trademark of any other person;  
                            </li>
                            <li className="mt-2">
                                Advocates, promotes or assists any unlawful act such as (by way of example only) 
                                copyright infringement or computer misuse.
                            </li>
                        </ul>

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            You shall not modify, translate into other languages, reverse engineer, decompile, disassemble or otherwise create derivative works 
                            from the Website or any documentation concerning the Website.
                        </p> 

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            You shall not transfer, lend, rent, lease, distribute the Website, or use it for providing services to a third party, or grant any rights 
                            to the Website or any documentation concerning the Website to a third party.
                        </p> 

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            Misuse of any trademarks or any other content displayed on the Website is prohibited.
                        </p> 
                    
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            You shall not copy and/or duplicate and/or distribute and/or publish and/or use any content in the Website, directly or indirectly, 
                            by way of a violation of our Intellectual Property Rights.
                        </p> 

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            Moreover, you shall not make any attempts to use the Website or part thereof for malicious intentions.
                        </p> 

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            Also we are not responsible for the way you use the Website.
                        </p> 

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            It is clarified that we may adopt, against a user who violated the present Agreement, any legal measures at our 
                            disposal pursuant to the applicable laws.
                        </p> 

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            All disputes arising from the usage of the Website, shall be governed by and construed in accordance with the laws of the United States of America, 
                            and shall be submitted to the sole jurisdiction of the competent courts of New York, the United States of America. 
                        </p> 
                        </>
                    )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenAvaibility(!isOpenAvaibility)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Availability of the website security and accuracy
                        </p>
                        {isOpenAvaibility ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenAvaibility && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                In order to use the Website, you are required to have a compatible electronic device (computer, mobile phone or tablet) and Internet access. 
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We do not warrant that the Website will be compatible with all hardware and software which you may use.
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We make no warranty that your access to the Website will be uninterrupted, timely or error-free.
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                You acknowledge that the Website is provided via the Internet, therefore, the quality and availability of the Website may be affected by 
                                factors outside our reasonable control. 
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We may add new features to the Website, change, update, upgrade, modify it or anything described in it without noticing you. If the need arises, 
                                we may suspend access to the Website, or close it indefinitely.
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                You also warrant that any information that you submit or send us via the Website is true, accurate and complete. 
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                If you decide not to use the Website for any reason you should stop accessing the Website. 
                            </p>     
                        </>
                    )}
                </div>
                  

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenCharges(!isOpenCharges)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Charges
                        </p>
                        {isOpenCharges ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenCharges && (
                        <>
                        
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Access to some services and/or additional features within the Apps presented on the Website requires paid subscriptions. The full 
                                list of Premium options and pricing is provided on the corresponding App’s page on AppStore or Google Play. You will have an opportunity to 
                                try Premium options during the free trial period as provided on the signup screen. After the free trial period expires an auto-renewing 
                                subscription period will start on a regular basis.<span className="font-medium italic"> Please mind that you will be charged automatically unless you cancel your subscription 
                                at least 24 hours before the end of the free trial period. </span> When you cancel your subscription you will still have access to basic functions 
                                of the App. Premium options are available during the whole free trial period.     
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                <span className="font-medium italic">Subscription with a free trial period will automatically renew to a paid subscription.</span>  Any unused portion of a free trial period, 
                                if offered, will be forfeited when the user purchases a subscription, where applicable. We reserve the right to modify, terminate or otherwise 
                                amend our offered subscription plans at any time.
                            </p> 

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                 <span className="font-medium italic">Your subscription will be automatically renewed within 24 hours before the current subscription ends.</span> Auto-renew option can be turned off 
                                in your Apple ID account settings / Google Play account settings at least 24 hours before the end of the current period. Payment will be 
                                charged to your Apple ID / Google Play Account at confirmation of purchase. No cancellation of the current subscription is allowed during 
                                active subscription period. Subscriptions are managed by you. Learn more about managing subscriptions (and how to cancel them) on 
                                {" "} <a href="https://support.apple.com/en-ca/118428" target="_blank" rel="noopener noreferrer" className="text-red-700 underline hover:no-underline"> Apple support page </a>{" "}
                                / 
                                {" "} <a href="https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en" target="_blank" rel="noopener noreferrer" className="text-red-700 underline hover:no-underline"> Google’s support page </a>{" "}
                                . Please note that removing the App from your device does not deactivate your subscription.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                <span className="font-medium italic">All sales are final. All purchases and subscription fees are non-refundable.</span> To the maximum extent
                                permitted by applicable law, every payment you make — including in-app purchases, one-time purchases, and auto-renewing
                                subscription fees — is final and non-refundable, and is charged for the right of access to the paid features for the billing
                                period selected, regardless of whether you actually use those features. We do not provide refunds, credits, or pro-rated
                                amounts for any partially used period, any unused period, any unused content or generations, accidental purchases, change of
                                mind, or for any amount already charged.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                <span className="font-medium italic">You acknowledge and agree before purchasing</span> that the App offers a free tier and/or a free trial period so
                                that you can evaluate the features before paying, that the price, billing period, and renewal terms are clearly displayed on
                                the purchase screen, and that by confirming a purchase you knowingly waive any right to a refund to the fullest extent the law
                                allows. Cancelling a subscription stops future renewals only; it does not refund or cancel the current billing period, and you
                                keep access to the paid features until the end of the period already paid for. Removing the App from your device does not cancel
                                your subscription or entitle you to a refund.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Because all purchases are processed exclusively by Apple or Google, we do not receive your payment details and are technically
                                unable to issue, approve, or deny refunds ourselves. Any refund is granted solely at the discretion of the relevant app store
                                under its own policies. If you believe you are entitled to a refund, you must contact the app store directly — Apple at
                                {" "} <a href="https://support.apple.com/118223" target="_blank" rel="noopener noreferrer" className="text-red-700 underline hover:no-underline"> reportaproblem.apple.com </a>{" "}
                                or Google at
                                {" "} <a href="https://support.google.com/googleplay/answer/2479637" target="_blank" rel="noopener noreferrer" className="text-red-700 underline hover:no-underline"> Google Play refunds </a>{" "}
                                . Nothing in this section is intended to limit any non-waivable statutory consumer rights you may have in your jurisdiction.
                            </p>

                        </>
                    )}
                </div>


                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenSources(!isOpenSources)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Third party websites and resources
                        </p>
                        {isOpenSources ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenSources && (
                        <>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                The Website may link you to other sites on the Internet and contracted third parties to provide you certain services. We have no control over 
                                and accept no responsibility for the content of any website or mobile application to which a link from the Website exists (unless we are the 
                                provider of those linked websites or mobile applications). Such linked websites and mobile applications are provided “as is” for your convenience 
                                only with no warranty, express or implied, for the information provided within them.
                            </p>   


                            <p className="mt-3 text-[#323232]  sm:text-[16px] text-[14px] font-poppins font-regular">
                                You acknowledge sole responsibility for and assume all risk arising from your use of any third-party websites or resources.
                            </p>

                            <p className="mt-3 text-[#323232]  sm:text-[16px] text-[14px] font-poppins font-regular">
                                If you have any queries, concerns or complaints about such third party websites or mobile applications (including, 
                                but not limited to, queries, concerns or complaints relating to products, orders for products, faulty products and refunds) 
                                you must direct them to the operator of that third party website or mobile application.
                            </p> 
                        </>
                    )}
                </div>
      
                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenDisclaimer(!isOpenDisclaimer)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Disclaimer of warranties
                        </p>
                        {isOpenDisclaimer ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenDisclaimer && (
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular uppercase">
                            You agree that your use of the website shall be at your sole risk. the services and all the materials, information, software, 
                            content integrated in the website are provided “as is” and “as available”. We do not make any warranties of any kind, either express 
                            or implied, with regard to the merchantability, technical compatibility or fitness for a particular purpose of any service, product, content 
                            or material provided pursuant to this agreement. We do not warrant that the functions contained on or through the website or its services 
                            will be available, uninterrupted or error-free, that defects will be corrected, or that the services or the servers that make the service 
                            available are free of viruses or other harmful components.
                        </p> 
                    )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenLimitation(!isOpenLimitation)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Limitation of liability
                        </p>
                        {isOpenLimitation ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenLimitation && (
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular uppercase">
                            In no event shall we be liable for damages of any type, whether direct or indirect, arising out of or in any way related to the website 
                            and services provided by the website. We shall not be liable under any circumstances for any special, consequential, incidental, exemplary 
                            or punitive damages, or loss of profit or revenues, even if we have been specifically advised of the possibility of such damages. We shall 
                            not be liable under any circumstances for damages arising out of or in any way related to products, services and/or information offered or 
                            provided by any third-parties and accessed through the website or by any other means. You also specifically acknowledge that we are not liable 
                            for costs or damages arising out of private or governmental legal actions related to your use of the website and its services in any country.
                        </p> 
                    )}
                </div>

                
                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenLegal(!isOpenLegal)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Legal compliace
                        </p>
                        {isOpenLegal ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenLegal && (
                         
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            You must represent and warrant that (i) you are not located in a country that is subject to a U.S. Government embargo, or that has been 
                            designated by the U.S. Government as a “terrorist supporting” country; and (ii) you are not listed on any U.S. Government list of prohibited 
                            or restricted parties.
                        </p>
                    )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenGoverning(!isOpenGoverning)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Governing law and claims
                        </p>
                        {isOpenGoverning ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenGoverning && (
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                This Agreement shall be governed by and construed in accordance with the laws of the State of New York, USA.
                            </p>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px]  font-poppins font-regular">
                            We make no representations that the Website is appropriate or available for use in other locations. Those who access 
                            or use the Website from other jurisdictions do so at their own volition and are responsible for compliance with local law.
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                If you choose to access or use the Website from or in locations outside of the United States, you are responsible for:
                            </p>

                            <ol className="list-decimal pl-6  text-[#323232] sm:text-[16px] text-[14px]  font-poppins">
                                <li className="mt-2">
                                    ensuring that what you are doing in that country is legal; and
                                </li>
                                <li className="mt-2">
                                    the consequences and compliance by you with all applicable laws, 
                                    regulations, bylaws, codes of practice, licenses, registrations, permits, and authorizations.
                                </li>
                            </ol>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                Any claims shall be exclusively decided by courts of competent jurisdiction in New York, the State of New York, USA 
                                and applicable Federal law shall govern, without regard to choice of law principles.
                            </p>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                If you ever wish to seek any relief from us, you agree to waive the ability to pursue class action.
                            </p>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                If any controversy, allegation, or claim (including any non-contractual claim) arises out of or relates to the Website 
                                and the Services provided by the Website or this Agreement, then you and we agree to send a written notice to each 
                                other providing a reasonable description of the dispute, along with a proposed resolution of it. The notice shall be 
                                sent based on the most recent contact information. For a period of sixty (60) days from the date of receipt of notice 
                                from the other party, you and us will engage in a dialogue in order to attempt to resolve the dispute, though nothing 
                                will require either you or us to resolve the dispute on terms which either you or us, in each of our sole discretion, 
                                are uncomfortable with.
                            </p>


                        </>
                    )}
                </div>


                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenTernimation(!isOpenTernimation)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Termination
                        </p>
                        {isOpenTernimation ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenTernimation && (
                         
                        <>
                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            We reserve the right to terminate this Agreement at any time at our sole discretion for any reason.
                        </p>

                        <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                            Upon any termination, (a) the rights and licenses granted to you herein shall terminate; (b) you must cease all access and/or use of the Website. 
                        </p>
                        </>
                        )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenSeverability(!isOpenSeverability)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                        Severability
                        </p>
                        {isOpenSeverability ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenSeverability && (
                         
                        <>
                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                If at any time any provision of this Agreement is or becomes illegal, invalid or unenforceable in any respect, that provision shall be more 
                                narrowly construed so that it becomes legal, valid and enforceable or, if this is not possible, deleted. The other terms of this Agreement 
                                shall continue to apply with full force and effect. 
                            </p>

                            <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                You shall not assign or transfer or purport to assign or transfer the contract between you and us to any other person. 
                            </p>
                        
                        </>
                        )}
                </div>

                <div className="mt-12">
                    <div
                        className="flex justify-between items-center cursor-pointer"
                        onClick={() => setIsOpenContactInfo(!isOpenContactInfo)}
                    >
                        <p className="text-[#323232] sm:text-[18px] text-[16px] font-poppins font-semibold">
                            Contact infomation
                        </p>
                        {isOpenContactInfo ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                    </div>

                    {isOpenContactInfo && (
                         
                        <>
                              <p className="mt-3 text-[#323232] sm:text-[16px] text-[14px] font-poppins font-regular">
                                We reserve the right to respond to your requests, questions, commentaries or suggestions. For these purposes you can use the form available 
                                within the “Contact us” section on the Website or reach us at <span className="text-red-700">tphuc.work@gmail.com  </span>  
                            </p>
                        </>
                        )}
                </div>
            </div>
            
            <Footer />
        </div>
    )
}

export default TermOfService;